<arm-layout>
  <div header>
    <div class="search-container">

      <arm-search (onSearch)="onSearch($event)"
                  [searchComponent]="registeredUsersSearchComponent"
                  [searchData]="searchData"
                  [searchTerms]="searchTerms">
      </arm-search>
    </div>

    <div class="action-buttons">
      <arm-action-bar (refreshClick)="refresh()"></arm-action-bar>

      <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button (click)="openColumnsConfiguration()" mat-menu-item>
          <span>Table columns</span>
        </button>
        <button (click)="exportToCSV()" mat-menu-item>
          <span>Export Register Users</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div main>
    <arm-table [data]="data.users" [displayedColumns]="displayedColumns"
               [length]="data.totalElements"
               (pageChanged)="pageChanged($event)"></arm-table>
  </div>
</arm-layout>
